if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        
        // Get all thumbnail containers (mobile and desktop)
        this.thumbnailContainers = this.querySelectorAll('[id^="GalleryThumbnails"]');
        if (!this.thumbnailContainers || this.thumbnailContainers.length === 0) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        
        // Attach click listeners to all thumbnail containers
        this.thumbnailContainers.forEach((thumbnailsContainer) => {
          thumbnailsContainer.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            const button = mediaToSwitch.querySelector('button');
            if (button) {
              button.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
            }
          });
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        if (!this.thumbnailContainers || this.thumbnailContainers.length === 0) return;
        const mediaId = event.detail.currentElement.dataset.mediaId;
        
        // Update thumbnails in all containers
        this.thumbnailContainers.forEach((thumbnailsContainer) => {
          const thumbnail = thumbnailsContainer.querySelector(`[data-target="${mediaId}"]`);
          if (thumbnail) {
            this.setActiveThumbnail(thumbnail, thumbnailsContainer);
          }
        });
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('!block');
        });
        activeMedia?.classList?.add('!block');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.thumbnailContainers && this.thumbnailContainers.length > 0) {
            this.thumbnailContainers.forEach((thumbnailsContainer) => {
              const activeThumbnail = thumbnailsContainer.querySelector(`[data-target="${mediaId}"]`);
              if (activeThumbnail && activeThumbnail.parentElement.firstChild !== activeThumbnail) {
                activeThumbnail.parentElement.prepend(activeThumbnail);
              }
            });
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.thumbnailContainers || this.thumbnailContainers.length === 0) return;
        
        // Update thumbnails in all containers
        let activeThumbnail = null;
        this.thumbnailContainers.forEach((thumbnailsContainer) => {
          const thumbnail = thumbnailsContainer.querySelector(`[data-target="${mediaId}"]`);
          if (thumbnail) {
            this.setActiveThumbnail(thumbnail, thumbnailsContainer);
            if (!activeThumbnail) activeThumbnail = thumbnail;
          }
        });
        
        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail, thumbnailsContainer) {
        if (!thumbnail) return;
        
        // Use provided container or find the one containing this thumbnail
        const container = thumbnailsContainer || thumbnail.closest('[id^="GalleryThumbnails"]');
        if (!container) return;

        // Remove aria-current from all buttons in this container
        container.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
        
        // Set aria-current on the active thumbnail button
        const button = thumbnail.querySelector('button');
        if (button) {
          button.setAttribute('aria-current', true);
        }
        
        // Scroll thumbnail into view if needed
        if (container.isSlideVisible && container.isSlideVisible(thumbnail, 10)) return;
        if (container.slider) {
          container.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
